export const getSubscopeName = (gallery) => {
  if (gallery.isImage() && gallery.isBothFamilies()) {
    return '';
  }
  const prefix = 'tab-';
  if (gallery.isPhotography()) {
    return `${prefix}Photos`;
  }
  if (gallery.isVector()) {
    return `${prefix}Vectors`;
  }
  if (gallery.isIllustration()) {
    return `${prefix}Illustrations`;
  }
  if (gallery.hasEditorialProduct()) {
    return `${prefix}${gallery.searchParameters.editorialproducts}`;
  }
  if (gallery.isCreativeFilmOnly()) {
    return `${prefix}CreativeVideo`;
  }
  if (gallery.isEditorialFilmOnly()) {
    return `${prefix}EditorialVideo`;
  }
  if (
    gallery.isCreativeImageOnly() ||
    gallery.isEditorialImageOnly() ||
    gallery.isAllFilm()
  ) {
    return `${prefix}AllResults`;
  }
  return null;
};

const getSearchTools = () => localStorage.getItem('tracking-data.search-tools');

const getElementLocation = () => {
  switch (getSearchTools()) {
    case 'ADP_Keyword_Browse_Click':
      return 'keyword_button_adp';
    case 'ADP_People_Also_Searched_For_Keyword_Click':
      return 'adp_people_also_searched_for_keyword_link';
    default:
      return undefined;
  }
};

export const getSearchType = (gallery) => {
  const trackingData = window.tracking_data;
  const { localStorage } = window;
  const searchTools = getSearchTools();

  if (searchTools && searchTools.includes('MLT'))
    return 'keyword-blank-similar_images';
  if (gallery.isBlankPhrase()) return 'keyword-blank';
  if (gallery.isAssetIdSearch()) return 'AssetID';
  if (gallery.isFamilyCorrected()) return 'AssetFamilyCorrection';
  if (trackingData.gallery_data.spellcheck_search) return 'keyword-spellcheck';

  const currentPhrase = gallery.searchParameters.phrase;
  const previousSearchType = localStorage.getItem('previous_search_type') || '';
  const previousPhraseIncluded = previousSearchType && currentPhrase;
  const autosuggestModifier = searchTools?.startsWith('autosuggest')
    ? `-${searchTools}`
    : '';

  const autosuggestRepeated =
    previousSearchType === 'keyword-autosuggest' && autosuggestModifier;
  if (searchTools === 'preview-related') {
    return 'keyword-related';
  }
  if (previousPhraseIncluded) return 'keyword-includes original';
  if (previousPhraseIncluded && autosuggestRepeated)
    return 'keyword-autosuggest includes original';

  if (
    searchTools === 'ADP_Keyword_Browse_Click' ||
    searchTools === 'ADP_People_Also_Searched_For_Keyword_Click'
  ) {
    return 'keyword-browse';
  }

  return `keyword${autosuggestModifier}`;
};

const getAppliedFilterValues = (appliedFilters) => {
  const values = [];
  for (const filter of appliedFilters) {
    values.push(`${filter.name}: ${filter.value}`);
  }
  return values;
};

export const getPaAgreementType = () => {
  const trackingData = window.tracking_data;
  if (!trackingData) return null;

  let pa;
  // find applied pa agreement filter from query
  const agreementFilter =
    trackingData.search_query.agreements != null
      ? trackingData.search_query.agreements.split(',')
      : undefined;
  if (agreementFilter) {
    for (const filteredAgreement of agreementFilter) {
      if (filteredAgreement.indexOf('pa') > -1) {
        pa = filteredAgreement.split(':')[1];
      }
    }
  }

  // find all agreement data to get agreement type of applied pa filter
  const activeAgreements = trackingData.active_agreements || {};
  if (activeAgreements.PA) {
    for (const agreement of activeAgreements.PA) {
      if (pa === agreement.Id.toString()) {
        return agreement.PaAgreementType;
      }
    }
  }

  return 'none';
};

export const getSearchCategory = (gallery) => {
  if (window.currentSite.isGetty) {
    return gallery.isBothFamilies()
      ? 'creative,editorial'
      : gallery.searchParameters.family;
  }
  if (gallery.searchParameters?.alloweduse === 'availableforalluses') {
    return 'creative';
  }
  if (gallery.searchParameters?.alloweduse === 'editorialuseonly') {
    return 'editorial';
  }

  return 'creative,editorial';
};

export const prepareTrackingData = (
  gallery,
  site,
  appliedFilters,
  isPanelOpen,
  layout
) => {
  const trackingData = window.tracking_data;
  if (!trackingData) return;
  const { sessionStorage } = window;
  if (!sessionStorage) return;
  const searchResultDisplayOptions = [];
  searchResultDisplayOptions.push(isPanelOpen ? 'open' : 'closed');
  searchResultDisplayOptions.push(layout);
  if (gallery.isGroupedByEvent()) {
    searchResultDisplayOptions.push('group_by_event');
  } else {
    searchResultDisplayOptions.push(
      gallery.searchParameters.assettype === 'image'
        ? 'group_by_pictures_and_images'
        : 'group_by_videos'
    );
  }

  const displayOption = trackingData.search_result_display_option
    ? trackingData.search_result_display_option.split(',')
    : [];
  trackingData.search_result_display_option = searchResultDisplayOptions
    .concat(displayOption)
    .join(',');
  trackingData.search_result_page_depth = gallery.pageNumber();
  if (gallery.hasEditorialProduct()) {
    trackingData.search_sub_category =
      gallery.searchParameters.editorialproducts;
  }
  trackingData.search_results_layout =
    layout === 'mosaic' ? 'mosaic_layout' : 'grid_layout';
  trackingData.refine_panel_display_state = isPanelOpen
    ? 'refine_open'
    : 'refine_closed';
  trackingData.search_breadcrumbs = getAppliedFilterValues(appliedFilters);
  trackingData.ui_element_location = getElementLocation();
  trackingData.search_type = getSearchType(gallery);
  if (getSubscopeName(gallery)) {
    trackingData.search_type += `|${getSubscopeName(gallery)}`;
  }
  trackingData.search_query.phrase = gallery.searchParameters.phrase;
  trackingData.search_result_count = gallery.totalResults;
  trackingData.search_category = getSearchCategory(gallery);
  sessionStorage.setItem('previous_search_type', trackingData.search_type);
};
